module.exports = __webpack_public_path__ + "img/arnevet_no.1c83de8d.png";